import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  doc,
  getDoc,
  setDoc,
} from "firebase/firestore";

import {
  useNavigate,
} from "react-router-dom";

import {
  db,
} from "../firebase";

import "./EastWallet.css";



const EAST_WALLET_TRANSLATIONS = {
"en": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Phone Wallet",
  "Security setup required": "Security setup required",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Complete Profile",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Required",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Optional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Saved",
  "Pending": "Pending",
  "Added": "Added",
  "Saving...": "Saving...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Go back",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"sw": {
  "Checking security information...": "Inakagua taarifa za usalama...",
  "Phone Wallet": "Pochi ya Simu",
  "Security setup required": "Usanidi wa usalama unahitajika",
  "Redirecting to Profile": "Inaelekeza kwenye Wasifu",
  "You will be redirected automatically in": "Utaelekezwa kiotomatiki baada ya",
  "seconds": "sekunde",
  "Complete your security information there.": "Kamilisha taarifa zako za usalama hapo.",
  "Complete Profile": "Kamilisha Wasifu",
  "Mobile payment information": "Taarifa za malipo ya simu",
  "Complete Your Security Profile": "Kamilisha Wasifu Wako wa Usalama",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Kabla ya kuongeza pochi ya simu, tafadhali kamilisha taarifa zinazohitajika za usalama kwenye wasifu wako.",
  "Real Name": "Jina Halisi",
  "Required": "Inahitajika",
  "Withdrawal Password": "Nenosiri la Kutoa Pesa",
  "Security Question & Answer": "Swali na Jibu la Usalama",
  "Phone Wallet Fully Secured": "Pochi ya Simu Imelindwa Kikamilifu",
  "All wallet information has been securely saved.": "Taarifa zote za pochi zimehifadhiwa kwa usalama.",
  "Primary Phone Number": "Nambari Kuu ya Simu",
  "Primary Network": "Mtandao Mkuu",
  "Second Phone Number": "Nambari ya Pili ya Simu",
  "Second Network": "Mtandao wa Pili",
  "Fully Secured": "Imelindwa Kikamilifu",
  "Primary number, primary network, second number and second network are saved.": "Nambari kuu, mtandao mkuu, nambari ya pili na mtandao wa pili vimehifadhiwa.",
  "This wallet information is secured and cannot be edited.": "Taarifa hizi za pochi zimelindwa na haziwezi kuhaririwa.",
  "Wallet Setup Progress": "Maendeleo ya Usanidi wa Pochi",
  "Your saved wallet information is protected.": "Taarifa zako za pochi zilizohifadhiwa zinalindwa.",
  "Primary Number": "Nambari Kuu",
  "Not selected": "Haijachaguliwa",
  "Second Number": "Nambari ya Pili",
  "Not added": "Haijaongezwa",
  "Security Verification": "Uthibitishaji wa Usalama",
  "Please answer your security question before adding your phone wallet.": "Tafadhali jibu swali lako la usalama kabla ya kuongeza pochi ya simu.",
  "Your Answer": "Jibu Lako",
  "Enter your answer": "Ingiza jibu lako",
  "Verify Security": "Thibitisha Usalama",
  "Security Verified": "Usalama Umethibitishwa",
  "You can now add your phone wallet.": "Sasa unaweza kuongeza pochi ya simu.",
  "Secured": "Imelindwa",
  "Optional": "Hiari",
  "Primary number is already secured and cannot be changed.": "Nambari kuu tayari imelindwa na haiwezi kubadilishwa.",
  "Select your network": "Chagua mtandao wako",
  "You can add this number now or later.": "Unaweza kuongeza nambari hii sasa au baadaye.",
  "Select network for second number": "Chagua mtandao wa nambari ya pili",
  "Select the network used by your second number.": "Chagua mtandao unaotumiwa na nambari yako ya pili.",
  "Add a second number first.": "Ongeza nambari ya pili kwanza.",
  "Add Second Number": "Ongeza Nambari ya Pili",
  "You can add another phone number with its own mobile network.": "Unaweza kuongeza nambari nyingine ya simu yenye mtandao wake.",
  "Wallet Security Status": "Hali ya Usalama wa Pochi",
  "Saved": "Imehifadhiwa",
  "Pending": "Inasubiri",
  "Added": "Imeongezwa",
  "Saving...": "Inahifadhi...",
  "Save Phone Wallet": "Hifadhi Pochi ya Simu",
  "Save Primary Network": "Hifadhi Mtandao Mkuu",
  "Save Second Network": "Hifadhi Mtandao wa Pili",
  "Save Wallet Information": "Hifadhi Taarifa za Pochi",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Nambari yako kuu na mtandao wake vimelindwa. Unaweza kurudi wakati wowote kuongeza nambari ya pili na kuchagua mtandao wake.",
  "Go back": "Rudi nyuma",
  "Failed to load wallet information.": "Imeshindwa kupakia taarifa za pochi.",
  "Security information is unavailable.": "Taarifa za usalama hazipatikani.",
  "Please enter your security answer.": "Tafadhali ingiza jibu lako la usalama.",
  "Incorrect security answer. Please try again.": "Jibu la usalama si sahihi. Tafadhali jaribu tena.",
  "Security verified successfully.": "Usalama umethibitishwa kwa mafanikio.",
  "Please log in again.": "Tafadhali ingia tena.",
  "Please complete your security profile first.": "Tafadhali kamilisha kwanza wasifu wako wa usalama.",
  "Please complete security verification first.": "Tafadhali kamilisha kwanza uthibitishaji wa usalama.",
  "Please enter your primary phone number.": "Tafadhali ingiza nambari yako kuu ya simu.",
  "Please enter a valid primary phone number.": "Tafadhali ingiza nambari kuu ya simu iliyo sahihi.",
  "Please select the network for your primary phone number.": "Tafadhali chagua mtandao wa nambari yako kuu ya simu.",
  "Please enter a valid second phone number.": "Tafadhali ingiza nambari ya pili ya simu iliyo sahihi.",
  "The second phone number must be different from the primary number.": "Nambari ya pili lazima iwe tofauti na nambari kuu.",
  "Please select the network for your second phone number.": "Tafadhali chagua mtandao wa nambari yako ya pili.",
  "Phone wallet fully secured successfully.": "Pochi ya simu imelindwa kikamilifu.",
  "Primary number and network saved. You can add a second number anytime.": "Nambari kuu na mtandao vimehifadhiwa. Unaweza kuongeza nambari ya pili wakati wowote.",
  "Primary number saved. Please select its mobile network.": "Nambari kuu imehifadhiwa. Tafadhali chagua mtandao wake.",
  "Second number saved. Please select its mobile network.": "Nambari ya pili imehifadhiwa. Tafadhali chagua mtandao wake.",
  "Phone wallet information saved successfully.": "Taarifa za pochi ya simu zimehifadhiwa kwa mafanikio.",
  "Failed to save phone wallet information. Please try again.": "Imeshindwa kuhifadhi taarifa za pochi ya simu. Tafadhali jaribu tena.",
  "Loading wallet": "Inapakia pochi",
  "Please wait...": "Tafadhali subiri...",
  "Other Wallet": "Pochi Nyingine",
  "Manage your international payment wallets": "Simamia pochi zako za malipo za kimataifa",
  "PAYMENT WALLET": "POCHI YA MALIPO",
  "Other Country": "Nchi Nyingine",
  "Add a wallet from another supported country.": "Ongeza pochi kutoka nchi nyingine inayoungwa mkono.",
  "Security profile incomplete": "Wasifu wa usalama haujakamilika",
  "Complete your profile before adding a payment wallet.": "Kamilisha wasifu wako kabla ya kuongeza pochi ya malipo.",
  "Wallet accounts": "Akaunti za pochi",
  "slot": "slot",
  "available": "zinapatikana",
  "Success": "Imefanikiwa",
  "No wallets added yet": "Bado hakuna pochi zilizoongezwa",
  "saved account": "saved account",
  "No wallet connected": "Hakuna pochi iliyounganishwa",
  "Add an account from a supported country to use it for withdrawals.": "Ongeza akaunti kutoka nchi inayoungwa mkono ili uitumie kutoa fedha.",
  "Add Wallet": "Ongeza Pochi",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Taarifa za pochi zimehifadhiwa kwa usalama na haziwezi kuhaririwa baada ya kuthibitishwa.",
  "SAVED WALLET": "POCHI ILIYOHIFADHIWA",
  "Country": "Nchi",
  "Currency": "Sarafu",
  "Network": "Mtandao",
  "Account Number": "Nambari ya Akaunti",
  "Wallet Secured": "Pochi Imelindwa",
  "This wallet cannot be edited.": "Pochi hii haiwezi kuhaririwa.",
  "Close": "Funga",
  "NEW PAYMENT WALLET": "POCHI MPYA YA MALIPO",
  "Enter your wallet information": "Weka taarifa za pochi yako",
  "Account Name": "Jina la Akaunti",
  "Select country": "Chagua nchi",
  "Country Code": "Msimbo wa Nchi",
  "Payment Network": "Mtandao wa Malipo",
  "Select network": "Chagua mtandao",
  "Wallet Number": "Nambari ya Pochi",
  "Enter account number": "Weka nambari ya akaunti",
  "Make sure the wallet number and network are correct before confirming.": "Hakikisha nambari ya pochi na mtandao ni sahihi kabla ya kuthibitisha.",
  "SAVING...": "INAHIFADHI...",
  "CONFIRM WALLET": "THIBITISHA POCHI",
  "Cancel": "Ghairi",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Tafadhali kamilisha kwanza wasifu wako wa usalama ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Kikomo kimefikiwa: akaunti 2 pekee zinaruhusiwa.",
  "Enter 5 - 25 digits.": "Weka tarakimu 5–25.",
  "Unable to load wallet information.": "Imeshindwa kupakia taarifa za pochi.",
  "Maximum 2 wallets are allowed.": "Pochi zisizozidi 2 zinaruhusiwa.",
  "Please select a country.": "Tafadhali chagua nchi.",
  "Selected country is invalid.": "Nchi iliyochaguliwa si sahihi.",
  "Please select your network.": "Tafadhali chagua mtandao wako.",
  "Please enter wallet number.": "Tafadhali weka nambari ya pochi.",
  "Security profile was not found.": "Wasifu wa usalama haukupatikana.",
  "Wallet added successfully.": "Pochi imeongezwa kikamilifu.",
  "Unable to save wallet.": "Imeshindwa kuhifadhi pochi.",
  "Wallet limit reached": "Kikomo cha pochi kimefikiwa",
  "Saved Wallets": "Pochi Zilizohifadhiwa",
  "Add New Wallet": "Ongeza Pochi Mpya",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"pt": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Carteira Telefônica",
  "Security setup required": "Configuração de segurança necessária",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Completar perfil",
  "Mobile payment information": "Informações de pagamento móvel",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Nome verdadeiro",
  "Required": "Obrigatório",
  "Withdrawal Password": "Senha de saque",
  "Security Question & Answer": "Pergunta e resposta de segurança",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Número de telefone principal",
  "Primary Network": "Rede principal",
  "Second Phone Number": "Segundo número de telefone",
  "Second Network": "Segunda rede",
  "Fully Secured": "Totalmente protegido",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Verificação de segurança",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Sua resposta",
  "Enter your answer": "Digite sua resposta",
  "Verify Security": "Verificar segurança",
  "Security Verified": "Segurança verificada",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Protegido",
  "Optional": "Opcional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Selecione sua rede",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Adicionar segundo número",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Status de segurança da carteira",
  "Saved": "Salvo",
  "Pending": "Pendente",
  "Added": "Adicionado",
  "Saving...": "Salvando...",
  "Save Phone Wallet": "Salvar carteira telefônica",
  "Save Primary Network": "Salvar rede principal",
  "Save Second Network": "Salvar segunda rede",
  "Save Wallet Information": "Salvar informações da carteira",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Voltar",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"fr": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Portefeuille téléphonique",
  "Security setup required": "Configuration de sécurité requise",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Compléter le profil",
  "Mobile payment information": "Informations de paiement mobile",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Nom réel",
  "Required": "Obligatoire",
  "Withdrawal Password": "Mot de passe de retrait",
  "Security Question & Answer": "Question et réponse de sécurité",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Numéro de téléphone principal",
  "Primary Network": "Réseau principal",
  "Second Phone Number": "Deuxième numéro de téléphone",
  "Second Network": "Deuxième réseau",
  "Fully Secured": "Entièrement sécurisé",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Vérification de sécurité",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Votre réponse",
  "Enter your answer": "Saisissez votre réponse",
  "Verify Security": "Vérifier la sécurité",
  "Security Verified": "Sécurité vérifiée",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Sécurisé",
  "Optional": "Facultatif",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Sélectionnez votre réseau",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Ajouter un deuxième numéro",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "État de sécurité du portefeuille",
  "Saved": "Enregistré",
  "Pending": "En attente",
  "Added": "Ajouté",
  "Saving...": "Enregistrement...",
  "Save Phone Wallet": "Enregistrer le portefeuille",
  "Save Primary Network": "Enregistrer le réseau principal",
  "Save Second Network": "Enregistrer le deuxième réseau",
  "Save Wallet Information": "Enregistrer les informations",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Retour",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"es": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Billetera telefónica",
  "Security setup required": "Se requiere configuración de seguridad",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Completar perfil",
  "Mobile payment information": "Información de pago móvil",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Nombre real",
  "Required": "Obligatorio",
  "Withdrawal Password": "Contraseña de retiro",
  "Security Question & Answer": "Pregunta y respuesta de seguridad",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Número de teléfono principal",
  "Primary Network": "Red principal",
  "Second Phone Number": "Segundo número de teléfono",
  "Second Network": "Segunda red",
  "Fully Secured": "Totalmente protegido",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Verificación de seguridad",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Tu respuesta",
  "Enter your answer": "Introduce tu respuesta",
  "Verify Security": "Verificar seguridad",
  "Security Verified": "Seguridad verificada",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Protegido",
  "Optional": "Opcional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Selecciona tu red",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Añadir segundo número",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Estado de seguridad de la billetera",
  "Saved": "Guardado",
  "Pending": "Pendiente",
  "Added": "Añadido",
  "Saving...": "Guardando...",
  "Save Phone Wallet": "Guardar billetera",
  "Save Primary Network": "Guardar red principal",
  "Save Second Network": "Guardar segunda red",
  "Save Wallet Information": "Guardar información",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Volver",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"pt-AO": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Carteira Telefônica",
  "Security setup required": "Configuração de segurança necessária",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Completar perfil",
  "Mobile payment information": "Informações de pagamento móvel",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Nome verdadeiro",
  "Required": "Obrigatório",
  "Withdrawal Password": "Senha de saque",
  "Security Question & Answer": "Pergunta e resposta de segurança",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Número de telefone principal",
  "Primary Network": "Rede principal",
  "Second Phone Number": "Segundo número de telefone",
  "Second Network": "Segunda rede",
  "Fully Secured": "Totalmente protegido",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Verificação de segurança",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Sua resposta",
  "Enter your answer": "Digite sua resposta",
  "Verify Security": "Verificar segurança",
  "Security Verified": "Segurança verificada",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Protegido",
  "Optional": "Opcional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Selecione sua rede",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Adicionar segundo número",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Status de segurança da carteira",
  "Saved": "Salvo",
  "Pending": "Pendente",
  "Added": "Adicionado",
  "Saving...": "Salvando...",
  "Save Phone Wallet": "Salvar carteira telefônica",
  "Save Primary Network": "Salvar rede principal",
  "Save Second Network": "Salvar segunda rede",
  "Save Wallet Information": "Salvar informações da carteira",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Voltar",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"ar": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "محفظة الهاتف",
  "Security setup required": "يلزم إعداد الأمان",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "إكمال الملف الشخصي",
  "Mobile payment information": "معلومات الدفع عبر الهاتف",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "الاسم الحقيقي",
  "Required": "مطلوب",
  "Withdrawal Password": "كلمة مرور السحب",
  "Security Question & Answer": "سؤال الأمان وإجابته",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "رقم الهاتف الأساسي",
  "Primary Network": "الشبكة الأساسية",
  "Second Phone Number": "رقم الهاتف الثاني",
  "Second Network": "الشبكة الثانية",
  "Fully Secured": "مؤمّن بالكامل",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "التحقق الأمني",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "إجابتك",
  "Enter your answer": "أدخل إجابتك",
  "Verify Security": "تحقق من الأمان",
  "Security Verified": "تم التحقق من الأمان",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "مؤمّن",
  "Optional": "اختياري",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "اختر شبكتك",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "إضافة رقم ثانٍ",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "حالة أمان المحفظة",
  "Saved": "تم الحفظ",
  "Pending": "قيد الانتظار",
  "Added": "تمت الإضافة",
  "Saving...": "جارٍ الحفظ...",
  "Save Phone Wallet": "حفظ محفظة الهاتف",
  "Save Primary Network": "حفظ الشبكة الأساسية",
  "Save Second Network": "حفظ الشبكة الثانية",
  "Save Wallet Information": "حفظ معلومات المحفظة",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "رجوع",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"zh": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "手机钱包",
  "Security setup required": "需要设置安全信息",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "完善资料",
  "Mobile payment information": "移动支付信息",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "真实姓名",
  "Required": "必填",
  "Withdrawal Password": "提现密码",
  "Security Question & Answer": "安全问题与答案",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "主要电话号码",
  "Primary Network": "主要网络",
  "Second Phone Number": "第二个电话号码",
  "Second Network": "第二网络",
  "Fully Secured": "已完全保护",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "安全验证",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "你的答案",
  "Enter your answer": "输入答案",
  "Verify Security": "验证安全信息",
  "Security Verified": "安全验证成功",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "已保护",
  "Optional": "可选",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "选择网络",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "添加第二个号码",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "钱包安全状态",
  "Saved": "已保存",
  "Pending": "待处理",
  "Added": "已添加",
  "Saving...": "正在保存...",
  "Save Phone Wallet": "保存手机钱包",
  "Save Primary Network": "保存主要网络",
  "Save Second Network": "保存第二网络",
  "Save Wallet Information": "保存钱包信息",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "返回",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"hi": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "फोन वॉलेट",
  "Security setup required": "सुरक्षा सेटअप आवश्यक है",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "प्रोफ़ाइल पूरी करें",
  "Mobile payment information": "मोबाइल भुगतान जानकारी",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "वास्तविक नाम",
  "Required": "आवश्यक",
  "Withdrawal Password": "निकासी पासवर्ड",
  "Security Question & Answer": "सुरक्षा प्रश्न और उत्तर",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "प्राथमिक फ़ोन नंबर",
  "Primary Network": "प्राथमिक नेटवर्क",
  "Second Phone Number": "दूसरा फ़ोन नंबर",
  "Second Network": "दूसरा नेटवर्क",
  "Fully Secured": "पूरी तरह सुरक्षित",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "सुरक्षा सत्यापन",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "आपका उत्तर",
  "Enter your answer": "अपना उत्तर दर्ज करें",
  "Verify Security": "सुरक्षा सत्यापित करें",
  "Security Verified": "सुरक्षा सत्यापित",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "सुरक्षित",
  "Optional": "वैकल्पिक",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "अपना नेटवर्क चुनें",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "दूसरा नंबर जोड़ें",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "वॉलेट सुरक्षा स्थिति",
  "Saved": "सहेजा गया",
  "Pending": "लंबित",
  "Added": "जोड़ा गया",
  "Saving...": "सहेज रहा है...",
  "Save Phone Wallet": "फोन वॉलेट सहेजें",
  "Save Primary Network": "प्राथमिक नेटवर्क सहेजें",
  "Save Second Network": "दूसरा नेटवर्क सहेजें",
  "Save Wallet Information": "वॉलेट जानकारी सहेजें",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "वापस जाएँ",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"bn": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "ফোন ওয়ালেট",
  "Security setup required": "নিরাপত্তা সেটআপ প্রয়োজন",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "প্রোফাইল সম্পূর্ণ করুন",
  "Mobile payment information": "মোবাইল পেমেন্ট তথ্য",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "আসল নাম",
  "Required": "প্রয়োজনীয়",
  "Withdrawal Password": "উত্তোলন পাসওয়ার্ড",
  "Security Question & Answer": "নিরাপত্তা প্রশ্ন ও উত্তর",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "প্রাথমিক ফোন নম্বর",
  "Primary Network": "প্রাথমিক নেটওয়ার্ক",
  "Second Phone Number": "দ্বিতীয় ফোন নম্বর",
  "Second Network": "দ্বিতীয় নেটওয়ার্ক",
  "Fully Secured": "সম্পূর্ণ সুরক্ষিত",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "নিরাপত্তা যাচাই",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "আপনার উত্তর",
  "Enter your answer": "আপনার উত্তর লিখুন",
  "Verify Security": "নিরাপত্তা যাচাই করুন",
  "Security Verified": "নিরাপত্তা যাচাই হয়েছে",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "সুরক্ষিত",
  "Optional": "ঐচ্ছিক",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "নেটওয়ার্ক নির্বাচন করুন",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "দ্বিতীয় নম্বর যোগ করুন",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "ওয়ালেট নিরাপত্তার অবস্থা",
  "Saved": "সংরক্ষিত",
  "Pending": "অপেক্ষমাণ",
  "Added": "যোগ করা হয়েছে",
  "Saving...": "সংরক্ষণ হচ্ছে...",
  "Save Phone Wallet": "ফোন ওয়ালেট সংরক্ষণ করুন",
  "Save Primary Network": "প্রাথমিক নেটওয়ার্ক সংরক্ষণ",
  "Save Second Network": "দ্বিতীয় নেটওয়ার্ক সংরক্ষণ",
  "Save Wallet Information": "ওয়ালেট তথ্য সংরক্ষণ",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "ফিরে যান",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"ru": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Телефонный кошелёк",
  "Security setup required": "Требуется настройка безопасности",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Заполнить профиль",
  "Mobile payment information": "Информация о мобильных платежах",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Настоящее имя",
  "Required": "Обязательно",
  "Withdrawal Password": "Пароль вывода",
  "Security Question & Answer": "Контрольный вопрос и ответ",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Основной номер телефона",
  "Primary Network": "Основная сеть",
  "Second Phone Number": "Второй номер телефона",
  "Second Network": "Вторая сеть",
  "Fully Secured": "Полностью защищено",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Проверка безопасности",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Ваш ответ",
  "Enter your answer": "Введите ответ",
  "Verify Security": "Проверить безопасность",
  "Security Verified": "Безопасность подтверждена",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Защищено",
  "Optional": "Необязательно",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Выберите сеть",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Добавить второй номер",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Статус безопасности кошелька",
  "Saved": "Сохранено",
  "Pending": "Ожидает",
  "Added": "Добавлено",
  "Saving...": "Сохранение...",
  "Save Phone Wallet": "Сохранить кошелёк",
  "Save Primary Network": "Сохранить основную сеть",
  "Save Second Network": "Сохранить вторую сеть",
  "Save Wallet Information": "Сохранить данные кошелька",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Назад",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"de": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Telefon-Wallet",
  "Security setup required": "Sicherheitseinrichtung erforderlich",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Profil vervollständigen",
  "Mobile payment information": "Mobile Zahlungsinformationen",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Echter Name",
  "Required": "Erforderlich",
  "Withdrawal Password": "Auszahlungskennwort",
  "Security Question & Answer": "Sicherheitsfrage und -antwort",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primäre Telefonnummer",
  "Primary Network": "Primäres Netzwerk",
  "Second Phone Number": "Zweite Telefonnummer",
  "Second Network": "Zweites Netzwerk",
  "Fully Secured": "Vollständig gesichert",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Sicherheitsprüfung",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Deine Antwort",
  "Enter your answer": "Antwort eingeben",
  "Verify Security": "Sicherheit überprüfen",
  "Security Verified": "Sicherheit bestätigt",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Gesichert",
  "Optional": "Optional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Netzwerk auswählen",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Zweite Nummer hinzufügen",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet-Sicherheitsstatus",
  "Saved": "Gespeichert",
  "Pending": "Ausstehend",
  "Added": "Hinzugefügt",
  "Saving...": "Speichern...",
  "Save Phone Wallet": "Telefon-Wallet speichern",
  "Save Primary Network": "Primäres Netzwerk speichern",
  "Save Second Network": "Zweites Netzwerk speichern",
  "Save Wallet Information": "Wallet-Informationen speichern",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Zurück",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"it": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Portafoglio telefonico",
  "Security setup required": "Configurazione di sicurezza richiesta",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Completa profilo",
  "Mobile payment information": "Informazioni di pagamento mobile",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Nome reale",
  "Required": "Obbligatorio",
  "Withdrawal Password": "Password di prelievo",
  "Security Question & Answer": "Domanda e risposta di sicurezza",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Numero di telefono principale",
  "Primary Network": "Rete principale",
  "Second Phone Number": "Secondo numero di telefono",
  "Second Network": "Seconda rete",
  "Fully Secured": "Completamente protetto",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Verifica di sicurezza",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "La tua risposta",
  "Enter your answer": "Inserisci la risposta",
  "Verify Security": "Verifica sicurezza",
  "Security Verified": "Sicurezza verificata",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Protetto",
  "Optional": "Facoltativo",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Seleziona la rete",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Aggiungi secondo numero",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Stato di sicurezza del portafoglio",
  "Saved": "Salvato",
  "Pending": "In sospeso",
  "Added": "Aggiunto",
  "Saving...": "Salvataggio...",
  "Save Phone Wallet": "Salva portafoglio",
  "Save Primary Network": "Salva rete principale",
  "Save Second Network": "Salva seconda rete",
  "Save Wallet Information": "Salva informazioni",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Indietro",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"nl": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Telefoonportemonnee",
  "Security setup required": "Beveiligingsinstelling vereist",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Profiel voltooien",
  "Mobile payment information": "Mobiele betaalinformatie",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Echte naam",
  "Required": "Verplicht",
  "Withdrawal Password": "Opnamewachtwoord",
  "Security Question & Answer": "Beveiligingsvraag en antwoord",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primair telefoonnummer",
  "Primary Network": "Primair netwerk",
  "Second Phone Number": "Tweede telefoonnummer",
  "Second Network": "Tweede netwerk",
  "Fully Secured": "Volledig beveiligd",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Beveiligingscontrole",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Jouw antwoord",
  "Enter your answer": "Voer je antwoord in",
  "Verify Security": "Beveiliging verifiëren",
  "Security Verified": "Beveiliging geverifieerd",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Beveiligd",
  "Optional": "Optioneel",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Selecteer je netwerk",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Tweede nummer toevoegen",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Beveiligingsstatus portemonnee",
  "Saved": "Opgeslagen",
  "Pending": "In behandeling",
  "Added": "Toegevoegd",
  "Saving...": "Opslaan...",
  "Save Phone Wallet": "Telefoonportemonnee opslaan",
  "Save Primary Network": "Primair netwerk opslaan",
  "Save Second Network": "Tweede netwerk opslaan",
  "Save Wallet Information": "Portemonneegegevens opslaan",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Terug",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"tr": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Telefon Cüzdanı",
  "Security setup required": "Güvenlik kurulumu gerekli",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Profili tamamla",
  "Mobile payment information": "Mobil ödeme bilgileri",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Gerçek ad",
  "Required": "Gerekli",
  "Withdrawal Password": "Para çekme şifresi",
  "Security Question & Answer": "Güvenlik sorusu ve yanıtı",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Birincil telefon numarası",
  "Primary Network": "Birincil ağ",
  "Second Phone Number": "İkinci telefon numarası",
  "Second Network": "İkinci ağ",
  "Fully Secured": "Tamamen güvenli",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Güvenlik doğrulaması",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Yanıtınız",
  "Enter your answer": "Yanıtınızı girin",
  "Verify Security": "Güvenliği doğrula",
  "Security Verified": "Güvenlik doğrulandı",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Güvende",
  "Optional": "İsteğe bağlı",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Ağınızı seçin",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "İkinci numara ekle",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Cüzdan güvenlik durumu",
  "Saved": "Kaydedildi",
  "Pending": "Bekliyor",
  "Added": "Eklendi",
  "Saving...": "Kaydediliyor...",
  "Save Phone Wallet": "Telefon cüzdanını kaydet",
  "Save Primary Network": "Birincil ağı kaydet",
  "Save Second Network": "İkinci ağı kaydet",
  "Save Wallet Information": "Cüzdan bilgilerini kaydet",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Geri",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"ja": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "電話ウォレット",
  "Security setup required": "セキュリティ設定が必要です",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "プロフィールを完成",
  "Mobile payment information": "モバイル決済情報",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "本名",
  "Required": "必須",
  "Withdrawal Password": "出金パスワード",
  "Security Question & Answer": "セキュリティ質問と回答",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "メインの電話番号",
  "Primary Network": "メインネットワーク",
  "Second Phone Number": "2つ目の電話番号",
  "Second Network": "2つ目のネットワーク",
  "Fully Secured": "完全に保護済み",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "セキュリティ確認",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "回答",
  "Enter your answer": "回答を入力",
  "Verify Security": "セキュリティを確認",
  "Security Verified": "確認済み",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "保護済み",
  "Optional": "任意",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "ネットワークを選択",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "2つ目の番号を追加",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "ウォレットの安全状態",
  "Saved": "保存済み",
  "Pending": "保留中",
  "Added": "追加済み",
  "Saving...": "保存中...",
  "Save Phone Wallet": "電話ウォレットを保存",
  "Save Primary Network": "メインネットワークを保存",
  "Save Second Network": "2つ目のネットワークを保存",
  "Save Wallet Information": "ウォレット情報を保存",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "戻る",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"ko": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "휴대폰 지갑",
  "Security setup required": "보안 설정 필요",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "프로필 완료",
  "Mobile payment information": "모바일 결제 정보",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "실명",
  "Required": "필수",
  "Withdrawal Password": "출금 비밀번호",
  "Security Question & Answer": "보안 질문 및 답변",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "기본 전화번호",
  "Primary Network": "기본 네트워크",
  "Second Phone Number": "두 번째 전화번호",
  "Second Network": "두 번째 네트워크",
  "Fully Secured": "완전히 보호됨",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "보안 확인",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "답변",
  "Enter your answer": "답변 입력",
  "Verify Security": "보안 확인",
  "Security Verified": "보안 확인 완료",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "보호됨",
  "Optional": "선택 사항",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "네트워크 선택",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "두 번째 번호 추가",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "지갑 보안 상태",
  "Saved": "저장됨",
  "Pending": "대기 중",
  "Added": "추가됨",
  "Saving...": "저장 중...",
  "Save Phone Wallet": "휴대폰 지갑 저장",
  "Save Primary Network": "기본 네트워크 저장",
  "Save Second Network": "두 번째 네트워크 저장",
  "Save Wallet Information": "지갑 정보 저장",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "뒤로",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"vi": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Ví điện thoại",
  "Security setup required": "Cần thiết lập bảo mật",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Hoàn tất hồ sơ",
  "Mobile payment information": "Thông tin thanh toán di động",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Tên thật",
  "Required": "Bắt buộc",
  "Withdrawal Password": "Mật khẩu rút tiền",
  "Security Question & Answer": "Câu hỏi và câu trả lời bảo mật",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Số điện thoại chính",
  "Primary Network": "Mạng chính",
  "Second Phone Number": "Số điện thoại thứ hai",
  "Second Network": "Mạng thứ hai",
  "Fully Secured": "Được bảo mật hoàn toàn",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Xác minh bảo mật",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Câu trả lời của bạn",
  "Enter your answer": "Nhập câu trả lời",
  "Verify Security": "Xác minh bảo mật",
  "Security Verified": "Đã xác minh bảo mật",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Đã bảo mật",
  "Optional": "Tùy chọn",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Chọn mạng",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Thêm số thứ hai",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Trạng thái bảo mật ví",
  "Saved": "Đã lưu",
  "Pending": "Đang chờ",
  "Added": "Đã thêm",
  "Saving...": "Đang lưu...",
  "Save Phone Wallet": "Lưu ví điện thoại",
  "Save Primary Network": "Lưu mạng chính",
  "Save Second Network": "Lưu mạng thứ hai",
  "Save Wallet Information": "Lưu thông tin ví",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Quay lại",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"th": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Phone Wallet",
  "Security setup required": "Security setup required",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Complete Profile",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Required",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Optional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Saved",
  "Pending": "Pending",
  "Added": "Added",
  "Saving...": "Saving...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Go back",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"id": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Dompet Telepon",
  "Security setup required": "Pengaturan keamanan diperlukan",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Lengkapi profil",
  "Mobile payment information": "Informasi pembayaran seluler",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Nama asli",
  "Required": "Wajib",
  "Withdrawal Password": "Kata sandi penarikan",
  "Security Question & Answer": "Pertanyaan dan jawaban keamanan",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Nomor telepon utama",
  "Primary Network": "Jaringan utama",
  "Second Phone Number": "Nomor telepon kedua",
  "Second Network": "Jaringan kedua",
  "Fully Secured": "Sepenuhnya aman",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Verifikasi keamanan",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Jawaban Anda",
  "Enter your answer": "Masukkan jawaban",
  "Verify Security": "Verifikasi keamanan",
  "Security Verified": "Keamanan terverifikasi",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Aman",
  "Optional": "Opsional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Pilih jaringan",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Tambah nomor kedua",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Status keamanan dompet",
  "Saved": "Tersimpan",
  "Pending": "Menunggu",
  "Added": "Ditambahkan",
  "Saving...": "Menyimpan...",
  "Save Phone Wallet": "Simpan dompet telepon",
  "Save Primary Network": "Simpan jaringan utama",
  "Save Second Network": "Simpan jaringan kedua",
  "Save Wallet Information": "Simpan informasi dompet",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Kembali",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"ms": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Dompet Telefon",
  "Security setup required": "Persediaan keselamatan diperlukan",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Lengkapkan profil",
  "Mobile payment information": "Maklumat pembayaran mudah alih",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Nama sebenar",
  "Required": "Diperlukan",
  "Withdrawal Password": "Kata laluan pengeluaran",
  "Security Question & Answer": "Soalan dan jawapan keselamatan",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Nombor telefon utama",
  "Primary Network": "Rangkaian utama",
  "Second Phone Number": "Nombor telefon kedua",
  "Second Network": "Rangkaian kedua",
  "Fully Secured": "Dilindungi sepenuhnya",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Pengesahan keselamatan",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Jawapan anda",
  "Enter your answer": "Masukkan jawapan anda",
  "Verify Security": "Sahkan keselamatan",
  "Security Verified": "Keselamatan disahkan",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Dilindungi",
  "Optional": "Pilihan",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Pilih rangkaian",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Tambah nombor kedua",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Status keselamatan dompet",
  "Saved": "Disimpan",
  "Pending": "Menunggu",
  "Added": "Ditambah",
  "Saving...": "Menyimpan...",
  "Save Phone Wallet": "Simpan dompet telefon",
  "Save Primary Network": "Simpan rangkaian utama",
  "Save Second Network": "Simpan rangkaian kedua",
  "Save Wallet Information": "Simpan maklumat dompet",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Kembali",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"ur": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Phone Wallet",
  "Security setup required": "Security setup required",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Complete Profile",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Required",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Optional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Saved",
  "Pending": "Pending",
  "Added": "Added",
  "Saving...": "Saving...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Go back",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"fa": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Phone Wallet",
  "Security setup required": "Security setup required",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Complete Profile",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Required",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Optional",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Saved",
  "Pending": "Pending",
  "Added": "Added",
  "Saving...": "Saving...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Go back",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"ha": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Wallet na waya",
  "Security setup required": "Ana buƙatar saitin tsaro",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Kammala bayanin martaba",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Ana buƙata",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Na zaɓi",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "An adana",
  "Pending": "Ana jira",
  "Added": "An ƙara",
  "Saving...": "Ana adanawa...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Komawa",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"yo": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Apamọwọ Foonu",
  "Security setup required": "A nilo iṣeto aabo",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Pari profaili",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Ti a nilo",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Aṣayan",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Ti fipamọ",
  "Pending": "Nduro",
  "Added": "Ti fi kun",
  "Saving...": "N fipamọ...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Pada",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"zu": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Isikhwama Sefoni",
  "Security setup required": "Kudingeka ukusetha ukuphepha",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Qedela iphrofayela",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Kuyadingeka",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Ongakukhetha",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Kulondoloziwe",
  "Pending": "Kulindile",
  "Added": "Kungeziwe",
  "Saving...": "Kuyalondolozwa...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Buyela emuva",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"am": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "የስልክ ቦርሳ",
  "Security setup required": "የደህንነት ማዋቀር ያስፈልጋል",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "መገለጫን ያጠናቅቁ",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "ያስፈልጋል",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "አማራጭ",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "ተቀምጧል",
  "Pending": "በመጠባበቅ ላይ",
  "Added": "ተጨምሯል",
  "Saving...": "በማስቀመጥ ላይ...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "ተመለስ",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"so": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Boorsada Taleefanka",
  "Security setup required": "Dejinta amniga ayaa loo baahan yahay",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Dhammaystir astaanta",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Loo baahan yahay",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Ikhtiyaari",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "La kaydiyey",
  "Pending": "Sugaya",
  "Added": "La daray",
  "Saving...": "Waa la kaydinayaa...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Dib u noqo",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"rw": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Umufuka wa telefoni",
  "Security setup required": "Hakenewe igenamiterere ry'umutekano",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Uzuza umwirondoro",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Birakenewe",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Ntibitegetswe",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Byabitswe",
  "Pending": "Birategereje",
  "Added": "Byongeweho",
  "Saving...": "Birabikwa...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Subira inyuma",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"lg": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Wallet ya ssimu",
  "Security setup required": "Kyetaagisa okuteekawo obukuumi",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Maliriza profaayiro",
  "Mobile payment information": "Mobile payment information",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Real Name",
  "Required": "Kyetaagisa",
  "Withdrawal Password": "Withdrawal Password",
  "Security Question & Answer": "Security Question & Answer",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primary Phone Number",
  "Primary Network": "Primary Network",
  "Second Phone Number": "Second Phone Number",
  "Second Network": "Second Network",
  "Fully Secured": "Fully Secured",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Security Verification",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Your Answer",
  "Enter your answer": "Enter your answer",
  "Verify Security": "Verify Security",
  "Security Verified": "Security Verified",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Secured",
  "Optional": "Kyeyagalire",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Select your network",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Add Second Number",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Wallet Security Status",
  "Saved": "Kiterekeddwa",
  "Pending": "Kirindiriddwa",
  "Added": "Kyongeddwako",
  "Saving...": "Kiterekebwa...",
  "Save Phone Wallet": "Save Phone Wallet",
  "Save Primary Network": "Save Primary Network",
  "Save Second Network": "Save Second Network",
  "Save Wallet Information": "Save Wallet Information",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Ddayo",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
},
"af": {
  "Checking security information...": "Checking security information...",
  "Phone Wallet": "Telefoonbeursie",
  "Security setup required": "Sekuriteitsopstelling benodig",
  "Redirecting to Profile": "Redirecting to Profile",
  "You will be redirected automatically in": "You will be redirected automatically in",
  "seconds": "seconds",
  "Complete your security information there.": "Complete your security information there.",
  "Complete Profile": "Voltooi profiel",
  "Mobile payment information": "Mobiele betalingsinligting",
  "Complete Your Security Profile": "Complete Your Security Profile",
  "Before adding a phone wallet, please complete the required security information in your profile.": "Before adding a phone wallet, please complete the required security information in your profile.",
  "Real Name": "Regte naam",
  "Required": "Vereis",
  "Withdrawal Password": "Onttrekkingswagwoord",
  "Security Question & Answer": "Sekuriteitsvraag en antwoord",
  "Phone Wallet Fully Secured": "Phone Wallet Fully Secured",
  "All wallet information has been securely saved.": "All wallet information has been securely saved.",
  "Primary Phone Number": "Primêre telefoonnommer",
  "Primary Network": "Primêre netwerk",
  "Second Phone Number": "Tweede telefoonnommer",
  "Second Network": "Tweede netwerk",
  "Fully Secured": "Ten volle beveilig",
  "Primary number, primary network, second number and second network are saved.": "Primary number, primary network, second number and second network are saved.",
  "This wallet information is secured and cannot be edited.": "This wallet information is secured and cannot be edited.",
  "Wallet Setup Progress": "Wallet Setup Progress",
  "Your saved wallet information is protected.": "Your saved wallet information is protected.",
  "Primary Number": "Primary Number",
  "Not selected": "Not selected",
  "Second Number": "Second Number",
  "Not added": "Not added",
  "Security Verification": "Sekuriteitsverifikasie",
  "Please answer your security question before adding your phone wallet.": "Please answer your security question before adding your phone wallet.",
  "Your Answer": "Jou antwoord",
  "Enter your answer": "Voer jou antwoord in",
  "Verify Security": "Verifieer sekuriteit",
  "Security Verified": "Sekuriteit geverifieer",
  "You can now add your phone wallet.": "You can now add your phone wallet.",
  "Secured": "Beveilig",
  "Optional": "Opsioneel",
  "Primary number is already secured and cannot be changed.": "Primary number is already secured and cannot be changed.",
  "Select your network": "Kies jou netwerk",
  "You can add this number now or later.": "You can add this number now or later.",
  "Select network for second number": "Select network for second number",
  "Select the network used by your second number.": "Select the network used by your second number.",
  "Add a second number first.": "Add a second number first.",
  "Add Second Number": "Voeg tweede nommer by",
  "You can add another phone number with its own mobile network.": "You can add another phone number with its own mobile network.",
  "Wallet Security Status": "Beursie-sekuriteitstatus",
  "Saved": "Gestoor",
  "Pending": "Hangende",
  "Added": "Bygevoeg",
  "Saving...": "Stoor...",
  "Save Phone Wallet": "Stoor telefoonbeursie",
  "Save Primary Network": "Stoor primêre netwerk",
  "Save Second Network": "Stoor tweede netwerk",
  "Save Wallet Information": "Stoor beursie-inligting",
  "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.": "Your primary number and its network are protected. You can return anytime to add a second number and select its own network.",
  "Go back": "Terug",
  "Failed to load wallet information.": "Failed to load wallet information.",
  "Security information is unavailable.": "Security information is unavailable.",
  "Please enter your security answer.": "Please enter your security answer.",
  "Incorrect security answer. Please try again.": "Incorrect security answer. Please try again.",
  "Security verified successfully.": "Security verified successfully.",
  "Please log in again.": "Please log in again.",
  "Please complete your security profile first.": "Please complete your security profile first.",
  "Please complete security verification first.": "Please complete security verification first.",
  "Please enter your primary phone number.": "Please enter your primary phone number.",
  "Please enter a valid primary phone number.": "Please enter a valid primary phone number.",
  "Please select the network for your primary phone number.": "Please select the network for your primary phone number.",
  "Please enter a valid second phone number.": "Please enter a valid second phone number.",
  "The second phone number must be different from the primary number.": "The second phone number must be different from the primary number.",
  "Please select the network for your second phone number.": "Please select the network for your second phone number.",
  "Phone wallet fully secured successfully.": "Phone wallet fully secured successfully.",
  "Primary number and network saved. You can add a second number anytime.": "Primary number and network saved. You can add a second number anytime.",
  "Primary number saved. Please select its mobile network.": "Primary number saved. Please select its mobile network.",
  "Second number saved. Please select its mobile network.": "Second number saved. Please select its mobile network.",
  "Phone wallet information saved successfully.": "Phone wallet information saved successfully.",
  "Failed to save phone wallet information. Please try again.": "Failed to save phone wallet information. Please try again.",
  "Loading wallet": "Loading wallet",
  "Please wait...": "Please wait...",
  "Other Wallet": "Other Wallet",
  "Manage your international payment wallets": "Manage your international payment wallets",
  "PAYMENT WALLET": "PAYMENT WALLET",
  "Other Country": "Other Country",
  "Add a wallet from another supported country.": "Add a wallet from another supported country.",
  "Security profile incomplete": "Security profile incomplete",
  "Complete your profile before adding a payment wallet.": "Complete your profile before adding a payment wallet.",
  "Wallet accounts": "Wallet accounts",
  "slot": "slot",
  "available": "available",
  "Success": "Success",
  "No wallets added yet": "No wallets added yet",
  "saved account": "saved account",
  "No wallet connected": "No wallet connected",
  "Add an account from a supported country to use it for withdrawals.": "Add an account from a supported country to use it for withdrawals.",
  "Add Wallet": "Add Wallet",
  "Wallet information is securely stored and cannot be edited after confirmation.": "Wallet information is securely stored and cannot be edited after confirmation.",
  "SAVED WALLET": "SAVED WALLET",
  "Country": "Country",
  "Currency": "Currency",
  "Network": "Network",
  "Account Number": "Account Number",
  "Wallet Secured": "Wallet Secured",
  "This wallet cannot be edited.": "This wallet cannot be edited.",
  "Close": "Close",
  "NEW PAYMENT WALLET": "NEW PAYMENT WALLET",
  "Enter your wallet information": "Enter your wallet information",
  "Account Name": "Account Name",
  "Select country": "Select country",
  "Country Code": "Country Code",
  "Payment Network": "Payment Network",
  "Select network": "Select network",
  "Wallet Number": "Wallet Number",
  "Enter account number": "Enter account number",
  "Make sure the wallet number and network are correct before confirming.": "Make sure the wallet number and network are correct before confirming.",
  "SAVING...": "SAVING...",
  "CONFIRM WALLET": "CONFIRM WALLET",
  "Cancel": "Cancel",
  "Not available": "Not available",
  "Please complete your security profile first ⚠️": "Please complete your security profile first ⚠️",
  "Limit reached: Only 2 accounts are allowed.": "Limit reached: Only 2 accounts are allowed.",
  "Enter 5 - 25 digits.": "Enter 5 - 25 digits.",
  "Unable to load wallet information.": "Unable to load wallet information.",
  "Maximum 2 wallets are allowed.": "Maximum 2 wallets are allowed.",
  "Please select a country.": "Please select a country.",
  "Selected country is invalid.": "Selected country is invalid.",
  "Please select your network.": "Please select your network.",
  "Please enter wallet number.": "Please enter wallet number.",
  "Security profile was not found.": "Security profile was not found.",
  "Wallet added successfully.": "Wallet added successfully.",
  "Unable to save wallet.": "Unable to save wallet.",
  "Wallet limit reached": "Wallet limit reached",
  "Saved Wallets": "Saved Wallets",
  "Add New Wallet": "Add New Wallet",
  "You can add 1 more account": "You can add 1 more account",
  "You can add 2 more accounts": "You can add 2 more accounts"
}
};

const normalizeEastWalletLanguage = (value) => {
  if (!value || typeof value !== "string") return "en";

  const available = Object.keys(EAST_WALLET_TRANSLATIONS);
  const cleaned = value.trim().replace(/_/g, "-");
  if (available.includes(cleaned)) return cleaned;

  const exactInsensitive = available.find(
    (code) => code.toLowerCase() === cleaned.toLowerCase()
  );
  if (exactInsensitive) return exactInsensitive;

  // Support locale values such as fr-FR or en-US while preserving variants like pt-AO.
  const base = cleaned.split("-")[0].toLowerCase();
  const baseMatch = available.find((code) => code.toLowerCase() === base);
  return baseMatch || "en";
};

const getEastWalletLanguage = () => {
  try {
    return normalizeEastWalletLanguage(
      localStorage.getItem("language") ||
      localStorage.getItem("appLanguage") ||
      localStorage.getItem("lang") ||
      "en"
    );
  } catch {
    return "en";
  }
};

/* =========================================================
   COUNTRIES
========================================================= */

const countries = {

  "🇰🇪 Kenya": {
    name: "Kenya",
    code: "+254",
    currency: "KES",
    networks: [
      "Safaricom (M-Pesa)",
      "Airtel Kenya",
    ],
  },

  "🇲🇬 Madagascar": {
    name: "Madagascar",
    code: "+261",
    currency: "MGA",
    networks: [
      "Airtel",
      "Orange",
    ],
  },

  "🇧🇼 Botswana": {
    name: "Botswana",
    code: "+267",
    currency: "BWP",
    networks: [
      "Orange",
      "BTC",
      "Mascom",
    ],
  },

  "🇸🇸 South Sudan": {
    name: "South Sudan",
    code: "+211",
    currency: "SSP",
    networks: [
      "MGurush",
      "MTN",
    ],
  },

  "🇿🇼 Zimbabwe": {
    name: "Zimbabwe",
    code: "+263",
    currency: "USD",
    networks: [
      "EcoCash",
    ],
  },

  "🇲🇿 Mozambique": {
    name: "Mozambique",
    code: "+258",
    currency: "MZN",
    networks: [
      "Vodacom",
    ],
  },

  "🇲🇼 Malawi": {
    name: "Malawi",
    code: "+265",
    currency: "MWK",
    networks: [
      "Airtel",
      "TNM",
    ],
  },

  "🇿🇲 Zambia": {
    name: "Zambia",
    code: "+260",
    currency: "ZMW",
    networks: [
      "Zamtel",
      "Airtel Zambia",
      "MTN Zambia",
    ],
  },

  "🇹🇿 Tanzania": {
    name: "Tanzania",
    code: "+255",
    currency: "TZS",
    networks: [
      "BANK TRANSFER ONLY",
    ],
  },

  "🇨🇩 DRC - Congo": {
    name: "DRC - Congo",
    code: "+243",
    currency: "USD",
    networks: [
      "Airtel",
      "Vodacom Congo",
      "Orange",
      "Illico Cash",
    ],
  },

  "🇧🇮 Burundi": {
    name: "Burundi",
    code: "+257",
    currency: "BIF",
    networks: [
      "Ecocash",
      "Lumicash",
    ],
  },

  "🇷🇼 Rwanda": {
    name: "Rwanda",
    code: "+250",
    currency: "RWF",
    networks: [
      "Airtel Rwanda",
      "MTN Rwanda",
    ],
  },

  "🇺🇬 Uganda": {
    name: "Uganda",
    code: "+256",
    currency: "UGX",
    networks: [
      "Airtel",
      "MTN",
    ],
  },

};


/* =========================================================
   CONSTANTS
========================================================= */

const MAX_WALLETS = 2;


/* =========================================================
   MASK NUMBER
========================================================= */

const maskNumber = (
  number = ""
) => {

  const value =
    String(number || "")
      .replace(/\s/g, "")
      .replace(/-/g, "")
      .trim();


  if (!value) {
    return "Not available";
  }


  if (value.length <= 4) {
    return value;
  }


  return `•••• ${value.slice(-4)}`;

};


/* =========================================================
   COUNTRY ICON
========================================================= */

const getCountryIcon = (
  countryName
) => {

  const key =
    Object.keys(
      countries
    ).find(
      (key) =>
        countries[key].name ===
        countryName
    );


  if (!key) {
    return "🌍";
  }


  return key.split(" ")[0];

};


/* =========================================================
   OTHER COUNTRY WALLET
========================================================= */

export default function OtherCountryWallet() {

  const navigate =
    useNavigate();

  const [language, setLanguage] = useState(() => getEastWalletLanguage());

  useEffect(() => {
    const updateLanguage = (event) => {
      const eventLanguage =
        typeof event?.detail === "string"
          ? event.detail
          : event?.detail?.language;

      setLanguage(
        normalizeEastWalletLanguage(eventLanguage || getEastWalletLanguage())
      );
    };

    window.addEventListener("languageChanged", updateLanguage);
    window.addEventListener("storage", updateLanguage);
    window.addEventListener("focus", updateLanguage);

    return () => {
      window.removeEventListener("languageChanged", updateLanguage);
      window.removeEventListener("storage", updateLanguage);
      window.removeEventListener("focus", updateLanguage);
    };
  }, []);

  const t = (key) =>
    EAST_WALLET_TRANSLATIONS[language]?.[key] ||
    EAST_WALLET_TRANSLATIONS.en?.[key] ||
    key;


  /* =======================================================
     USERNAME
  ======================================================= */

  const username =
    localStorage.getItem(
      "username"
    ) || "";


  /* =======================================================
     WALLETS
  ======================================================= */

  const [
    wallets,
    setWallets,
  ] = useState([]);


  /* =======================================================
     SECURITY PROFILE
  ======================================================= */

  const [
    realName,
    setRealName,
  ] = useState("");


  const [
    withdrawPassword,
    setWithdrawPassword,
  ] = useState("");


  const [
    securityQuestion,
    setSecurityQuestion,
  ] = useState("");


  const [
    securityAnswer,
    setSecurityAnswer,
  ] = useState("");


  /* =======================================================
     LOADING
  ======================================================= */

  const [
    loading,
    setLoading,
  ] = useState(true);


  const [
    saving,
    setSaving,
  ] = useState(false);


  /* =======================================================
     MODAL
  ======================================================= */

  const [
    showModal,
    setShowModal,
  ] = useState(false);


  /* =======================================================
     WALLET DETAIL
  ======================================================= */

  const [
    selectedWallet,
    setSelectedWallet,
  ] = useState(null);


  /* =======================================================
     FORM
  ======================================================= */

  const [
    country,
    setCountry,
  ] = useState("");


  const [
    network,
    setNetwork,
  ] = useState("");


  const [
    number,
    setNumber,
  ] = useState("");


  /* =======================================================
     ERRORS
  ======================================================= */

  const [
    error,
    setError,
  ] = useState("");


  const [
    numberError,
    setNumberError,
  ] = useState("");


  /* =======================================================
     SUCCESS
  ======================================================= */

  const [
    success,
    setSuccess,
  ] = useState("");


  /* =======================================================
     SELECTED COUNTRY
  ======================================================= */

  const selectedCountry =
    countries[country] || null;


  /* =======================================================
     REMAINING WALLET SLOTS
  ======================================================= */

  const remainingWallets =
    Math.max(
      0,
      MAX_WALLETS -
      wallets.length
    );


  /* =======================================================
     PROFILE COMPLETE
  ======================================================= */

  const profileComplete =
    useMemo(() => {

      return (

        String(
          realName || ""
        ).trim() !== ""

        &&

        String(
          withdrawPassword || ""
        ).trim() !== ""

        &&

        String(
          securityQuestion || ""
        ).trim() !== ""

        &&

        String(
          securityAnswer || ""
        ).trim() !== ""

      );

    }, [
      realName,
      withdrawPassword,
      securityQuestion,
      securityAnswer,
    ]);


  /* =======================================================
     LOAD SECURITY + WALLETS
  ======================================================= */

  useEffect(() => {

    let mounted = true;


    const loadData =
      async () => {

        if (!username) {

          navigate(
            "/login",
            {
              replace: true,
            }
          );

          return;

        }


        try {

          setLoading(true);


          const securityRef =
            doc(
              db,
              "security",
              username
            );


          const snapshot =
            await getDoc(
              securityRef
            );


          if (!mounted) {
            return;
          }


          if (!snapshot.exists()) {

            setWallets([]);

            setRealName("");

            setWithdrawPassword("");

            setSecurityQuestion("");

            setSecurityAnswer("");

            return;

          }


          const data =
            snapshot.data();


          /* =============================================
             SECURITY PROFILE
          ============================================= */

          setRealName(
            data.realName || ""
          );


          setWithdrawPassword(
            data.withdrawPassword || ""
          );


          setSecurityQuestion(
            data.securityQuestion || ""
          );


          setSecurityAnswer(
            data.securityAnswer || ""
          );


          /* =============================================
             OTHER COUNTRY WALLETS
          ============================================= */

          const savedWallets =
            Array.isArray(
              data.wallets
            )
              ? data.wallets
              : [];


          setWallets(
            savedWallets
          );


        } catch (err) {

          console.error(
            "Other wallet loading error:",
            err
          );


          if (mounted) {

            setError(
              t("Unable to load wallet information.")
            );

          }

        } finally {

          if (mounted) {

            setLoading(false);

          }

        }

      };


    loadData();


    return () => {

      mounted = false;

    };

  }, [
    username,
    navigate,
  ]);


  /* =======================================================
     BODY SCROLL LOCK
  ======================================================= */

  useEffect(() => {

    document.body.style.overflow =
      showModal
        ? "hidden"
        : "";


    return () => {

      document.body.style.overflow =
        "";

    };

  }, [
    showModal,
  ]);


  /* =======================================================
     RESET FORM
  ======================================================= */

  const resetForm = () => {

    setCountry("");

    setNetwork("");

    setNumber("");

    setNumberError("");

    setError("");

  };


  /* =======================================================
     CLOSE ADD WALLET MODAL
  ======================================================= */

  const closeModal = () => {

    if (saving) {
      return;
    }


    setShowModal(false);

    resetForm();

  };


  /* =======================================================
     OPEN ADD WALLET MODAL
  ======================================================= */

  const openModal = () => {

    setError("");

    setSuccess("");


    if (!username) {

      navigate(
        "/login"
      );

      return;

    }


    if (!profileComplete) {

      alert(
        "Please complete your security profile first ⚠️"
      );

      navigate(
        "/profile"
      );

      return;

    }


    if (
      wallets.length >=
      MAX_WALLETS
    ) {

      alert(
        "Limit reached: Only 2 accounts are allowed."
      );

      return;

    }


    resetForm();

    setShowModal(true);

  };


  /* =======================================================
     COUNTRY CHANGE
  ======================================================= */

  const handleCountryChange = (
    event
  ) => {

    const value =
      event.target.value;


    /* ===============================================
       TANZANIA
       USE ADD CARD
    =============================================== */

    if (
      countries[value]?.name ===
      "Tanzania"
    ) {

      setShowModal(false);

      resetForm();

      navigate(
        "/add-card"
      );

      return;

    }


    setCountry(
      value
    );

    setNetwork("");

    setNumber("");

    setNumberError("");

    setError("");

  };


  /* =======================================================
     NUMBER CHANGE
  ======================================================= */

  const handleNumberChange = (
    event
  ) => {

    const value =
      event.target.value
        .replace(
          /\D/g,
          ""
        );


    setNumber(
      value
    );


    if (
      value.length > 0 &&
      (
        value.length < 5 ||
        value.length > 25
      )
    ) {

      setNumberError(
        "Enter 5 - 25 digits."
      );

    } else {

      setNumberError("");

    }

  };


  /* =======================================================
     SAVE WALLET
  ======================================================= */

  const handleSave =
    async () => {

      setError("");

      setSuccess("");

      setNumberError("");


      /* ===============================================
         LOGIN
      =============================================== */

      if (!username) {

        navigate(
          "/login"
        );

        return;

      }


      /* ===============================================
         SECURITY PROFILE
      =============================================== */

      if (!profileComplete) {

        alert(
          t("Please complete your security profile first.")
        );

        navigate(
          "/profile"
        );

        return;

      }


      /* ===============================================
         WALLET LIMIT
      =============================================== */

      if (
        wallets.length >=
        MAX_WALLETS
      ) {

        setError(
          t("Maximum 2 wallets are allowed.")
        );

        return;

      }


      /* ===============================================
         COUNTRY
      =============================================== */

      if (!country) {

        setError(
          t("Please select a country.")
        );

        return;

      }


      if (!selectedCountry) {

        setError(
          t("Selected country is invalid.")
        );

        return;

      }


      /* ===============================================
         NETWORK
      =============================================== */

      if (!network) {

        setError(
          t("Please select your network.")
        );

        return;

      }


      /* ===============================================
         NUMBER
      =============================================== */

      if (!number) {

        setError(
          t("Please enter wallet number.")
        );

        return;

      }


      if (
        number.length < 5 ||
        number.length > 25
      ) {

        setNumberError(
          t("Enter 5 - 25 digits.")
        );

        return;

      }


      try {

        setSaving(true);


        /* =============================================
           FIREBASE SECURITY DOCUMENT
        ============================================= */

        const securityRef =
          doc(
            db,
            "security",
            username
          );


        /* =============================================
           FRESH DATA
        ============================================= */

        const latestSnapshot =
          await getDoc(
            securityRef
          );


        if (
          !latestSnapshot.exists()
        ) {

          setError(
            t("Security profile was not found.")
          );

          navigate(
            "/profile"
          );

          return;

        }


        const latestData =
          latestSnapshot.data();


        /* =============================================
           FRESH SECURITY CHECK
        ============================================= */

        const complete =
          Boolean(

            String(
              latestData.realName ||
              ""
            ).trim()

            &&

            String(
              latestData.withdrawPassword ||
              ""
            ).trim()

            &&

            String(
              latestData.securityQuestion ||
              ""
            ).trim()

            &&

            String(
              latestData.securityAnswer ||
              ""
            ).trim()

          );


        if (!complete) {

          alert(
            t("Please complete your security profile first ⚠️")
          );

          navigate(
            "/profile"
          );

          return;

        }


        /* =============================================
           FRESH WALLET LIST
        ============================================= */

        const currentWallets =
          Array.isArray(
            latestData.wallets
          )
            ? latestData.wallets
            : [];


        if (
          currentWallets.length >=
          MAX_WALLETS
        ) {

          setWallets(
            currentWallets
          );

          setError(
            t("Maximum 2 wallets are allowed.")
          );

          return;

        }


        /* =============================================
           CREATE WALLET
        ============================================= */

        const newWallet = {

          country:
            selectedCountry.name,

          code:
            selectedCountry.code,

          currency:
            selectedCountry.currency,

          network:
            network,

          number:
            number,

          type:
            "other-country",

          walletSecured:
            true,

          createdAt:
            new Date(),

        };


        /* =============================================
           ADD TO ARRAY
        ============================================= */

        const updatedWallets = [

          ...currentWallets,

          newWallet,

        ];


        /* =============================================
           SAVE FIREBASE
        ============================================= */

        await setDoc(

          securityRef,

          {
            wallets:
              updatedWallets,
          },

          {
            merge: true,
          }

        );


        /* =============================================
           UPDATE UI
        ============================================= */

        setWallets(
          updatedWallets
        );


        setShowModal(false);

        resetForm();


        setSuccess(
          t("Wallet added successfully.")
        );


      } catch (err) {

        console.error(
          "Other wallet save error:",
          err
        );


        setError(
          err?.message ||
          t("Unable to save wallet.")
        );

      } finally {

        setSaving(false);

      }

    };


  /* =======================================================
     SELECT WALLET
  ======================================================= */

  const handleWalletClick = (
    wallet,
    index
  ) => {

    setSelectedWallet({
      ...wallet,
      index,
    });

  };


  /* =======================================================
     CLOSE WALLET DETAIL
  ======================================================= */

  const closeWalletDetail = () => {

    setSelectedWallet(null);

  };


  /* =======================================================
     LOADING SCREEN
  ======================================================= */

  if (loading) {

    return (

      <div className="wallet-page">

        <div className="wallet-loading-screen">

          <div className="wallet-loader" />

          <strong>{t("Loading wallet")}</strong>

          <span>{t("Please wait...")}</span>

        </div>

      </div>

    );

  }


  /* =======================================================
     RENDER
  ======================================================= */

  return (

    <div className="wallet-page">

      <div className="wallet-container">


        {/* =================================================
            HEADER
        ================================================= */}

        <header className="wallet-header">

          <button
            type="button"
            className="wallet-back"
            onClick={() =>
              navigate(-1)
            }
          >
            ←
          </button>


          <div className="wallet-header-content">

            <h1>{t("Other Wallet")}</h1>

            <p>{t("Manage your international payment wallets")}</p>

          </div>

        </header>


        {/* =================================================
            HERO
        ================================================= */}

        <section className="wallet-hero">

          <div className="wallet-hero-icon">
            ◎
          </div>


          <div className="wallet-hero-content">

            <span>{t("PAYMENT WALLET")}</span>

            <strong>{t("Other Country")}</strong>

            <p>{t("Add a wallet from another supported country.")}</p>

          </div>


          <div className="wallet-hero-count">

            <strong>
              {wallets.length}
            </strong>

            <span>
              / {MAX_WALLETS}
            </span>

          </div>

        </section>


        {/* =================================================
            PROFILE WARNING
        ================================================= */}

        {!profileComplete && (

          <section className="wallet-warning">

            <div className="wallet-warning-icon">
              !
            </div>


            <div className="wallet-warning-content">

              <strong>{t("Security profile incomplete")}</strong>

              <p>{t("Complete your profile before adding a payment wallet.")}</p>


              <button
                type="button"
                onClick={() =>
                  navigate("/profile")
                }
              >{t("Complete Profile")}</button>

            </div>

          </section>

        )}


        {/* =================================================
            CAPACITY
        ================================================= */}

        <section className="wallet-capacity">

          <div className="wallet-capacity-top">

            <div>

              <span>{t("Wallet accounts")}</span>

              <strong>
                {wallets.length} of {MAX_WALLETS}
              </strong>

            </div>


            <small>

              {remainingWallets} slot
              {remainingWallets === 1 ? "" : "s"}
              {" "}available

            </small>

          </div>


          <div className="wallet-capacity-track">

            <div
              className="wallet-capacity-fill"
              style={{
                width:
                  `${Math.min(
                    (
                      wallets.length /
                      MAX_WALLETS
                    ) * 100,
                    100
                  )}%`,
              }}
            />

          </div>

        </section>


        {/* =================================================
            SUCCESS
        ================================================= */}

        {success && (

          <div className="wallet-success">

            <span>
              ✓
            </span>


            <div>

              <strong>{t("Success")}</strong>

              <p>
                {success}
              </p>

            </div>


            <button
              type="button"
              onClick={() =>
                setSuccess("")
              }
            >
              ×
            </button>

          </div>

        )}


        {/* =================================================
            ERROR
        ================================================= */}

        {error && (

          <div className="wallet-error">

            <span>
              !
            </span>


            <p>
              {error}
            </p>


            <button
              type="button"
              onClick={() =>
                setError("")
              }
            >
              ×
            </button>

          </div>

        )}


        {/* =================================================
            ADD BUTTON
        ================================================= */}

        <button
          type="button"
          className="wallet-add-button"
          onClick={openModal}
          disabled={
            wallets.length >=
            MAX_WALLETS
          }
        >

          <span className="wallet-add-icon">
            +
          </span>


          <span className="wallet-add-text">

            <strong>{t("Add New Wallet")}</strong>

            <small>

              {wallets.length >= MAX_WALLETS

                ? "Wallet limit reached"

                : `You can add ${remainingWallets} more account${
                    remainingWallets === 1
                      ? ""
                      : "s"
                  }`

              }

            </small>

          </span>


          <span className="wallet-add-arrow">
            →
          </span>

        </button>


        {/* =================================================
            LIST HEADER
        ================================================= */}

        <div className="wallet-list-header">

          <div>

            <h2>{t("Saved Wallets")}</h2>

            <span>

              {wallets.length === 0

                ? "No wallets added yet"

                : `${wallets.length} saved account${
                    wallets.length === 1
                      ? ""
                      : "s"
                  }`

              }

            </span>

          </div>

        </div>


        {/* =================================================
            EMPTY STATE
        ================================================= */}

        {wallets.length === 0 ? (

          <div className="wallet-empty">

            <div className="wallet-empty-icon">
              +
            </div>


            <strong>{t("No wallet connected")}</strong>


            <p>{t("Add an account from a supported country to use it for withdrawals.")}</p>


            <button
              type="button"
              onClick={openModal}
            >{t("Add Wallet")}</button>

          </div>

        ) : (

          <div className="wallet-list">

            {wallets.map(
              (
                wallet,
                index
              ) => (

                <button
                  type="button"
                  key={
                    `${wallet.country}-${wallet.number}-${index}`
                  }
                  className="wallet-item"
                  onClick={() =>
                    handleWalletClick(
                      wallet,
                      index
                    )
                  }
                >

                  {/* ======================================
                      COUNTRY ICON
                  ====================================== */}

                  <div className="wallet-item-icon">

                    {getCountryIcon(
                      wallet.country
                    )}

                  </div>


                  {/* ======================================
                      CONTENT
                  ====================================== */}

                  <div className="wallet-item-content">

                    <div className="wallet-item-title">

                      <strong>
                        {wallet.country}
                      </strong>

                      <span>
                        {wallet.currency}
                      </span>

                    </div>


                    <p>
                      {wallet.network}
                    </p>


                    <small>

                      {wallet.code}{" "}

                      {maskNumber(
                        wallet.number
                      )}

                    </small>

                  </div>


                  {/* ======================================
                      STATUS
                  ====================================== */}

                  <div className="wallet-item-right">

                    <span className="wallet-secure-badge">
                      ✓
                    </span>

                    <span className="wallet-item-arrow">
                      ›
                    </span>

                  </div>

                </button>

              )
            )}

          </div>

        )}


        {/* =================================================
            FOOTER NOTE
        ================================================= */}

        <div className="wallet-footer-note">

          <span>
            🔒
          </span>

          <p>{t("Wallet information is securely stored and cannot be edited after confirmation.")}</p>

        </div>


      </div>


      {/* =====================================================
          WALLET DETAIL MODAL
      ===================================================== */}

      {selectedWallet && (

        <div
          className="wallet-detail-overlay"
          onClick={
            closeWalletDetail
          }
        >

          <div
            className="wallet-detail-modal"
            onClick={(event) =>
              event.stopPropagation()
            }
          >

            <div className="wallet-detail-header">

              <div>

                <span>{t("SAVED WALLET")}</span>

                <h3>
                  {selectedWallet.country}
                </h3>

              </div>


              <button
                type="button"
                onClick={
                  closeWalletDetail
                }
              >
                ×
              </button>

            </div>


            <div className="wallet-detail-main">

              <div className="wallet-detail-country-icon">

                {getCountryIcon(
                  selectedWallet.country
                )}

              </div>


              <div>

                <strong>
                  {selectedWallet.network}
                </strong>

                <span>
                  {selectedWallet.currency}
                </span>

              </div>

            </div>


            <div className="wallet-detail-row">

              <span>{t("Country")}</span>

              <strong>
                {selectedWallet.country}
              </strong>

            </div>


            <div className="wallet-detail-row">

              <span>{t("Currency")}</span>

              <strong>
                {selectedWallet.currency}
              </strong>

            </div>


            <div className="wallet-detail-row">

              <span>{t("Network")}</span>

              <strong>
                {selectedWallet.network}
              </strong>

            </div>


            <div className="wallet-detail-row">

              <span>{t("Account Number")}</span>

              <strong>

                {selectedWallet.code}{" "}

                {maskNumber(
                  selectedWallet.number
                )}

              </strong>

            </div>


            <div className="wallet-detail-secured">

              <span>
                ✓
              </span>


              <div>

                <strong>{t("Wallet Secured")}</strong>

                <small>{t("This wallet cannot be edited.")}</small>

              </div>

            </div>


            <button
              type="button"
              className="wallet-detail-close"
              onClick={
                closeWalletDetail
              }
            >{t("Close")}</button>

          </div>

        </div>

      )}


      {/* =====================================================
          ADD WALLET MODAL
      ===================================================== */}

      {showModal && (

        <div
          className="wallet-modal-overlay"
          onClick={
            closeModal
          }
        >

          <div
            className="wallet-modal"
            onClick={(event) =>
              event.stopPropagation()
            }
          >


            {/* ===============================================
                MODAL HEADER
            =============================================== */}

            <div className="wallet-modal-header">

              <div>

                <span>{t("NEW PAYMENT WALLET")}</span>

                <h2>{t("Add Wallet")}</h2>

                <p>{t("Enter your wallet information")}</p>

              </div>


              <button
                type="button"
                className="wallet-modal-close"
                onClick={
                  closeModal
                }
                disabled={
                  saving
                }
              >
                ×
              </button>

            </div>


            {/* ===============================================
                ACCOUNT NAME
            =============================================== */}

            <div className="wallet-account-box">

              <span>{t("Account Name")}</span>

              <strong>
                {realName || t("Not available")}
              </strong>

            </div>


            {/* ===============================================
                COUNTRY
            =============================================== */}

            <div className="wallet-field">

              <label>{t("Country")}</label>


              <select
                value={
                  country
                }
                onChange={
                  handleCountryChange
                }
                disabled={
                  saving
                }
              >

                <option value="">{t("Select country")}</option>


                {Object.keys(
                  countries
                ).map(
                  (
                    countryName
                  ) => (

                    <option
                      key={
                        countryName
                      }
                      value={
                        countryName
                      }
                    >
                      {countryName}
                    </option>

                  )
                )}

              </select>

            </div>


            {/* ===============================================
                COUNTRY INFORMATION
            =============================================== */}

            {selectedCountry && (

              <div className="wallet-country-info">

                <div>

                  <span>{t("Currency")}</span>

                  <strong>
                    {selectedCountry.currency}
                  </strong>

                </div>


                <div>

                  <span>{t("Country Code")}</span>

                  <strong>
                    {selectedCountry.code}
                  </strong>

                </div>

              </div>

            )}


            {/* ===============================================
                NETWORK
            =============================================== */}

            {selectedCountry && (

              <div className="wallet-field">

                <label>{t("Payment Network")}</label>


                <select
                  value={
                    network
                  }
                  onChange={(event) =>
                    setNetwork(
                      event.target.value
                    )
                  }
                  disabled={
                    saving
                  }
                >

                  <option value="">{t("Select network")}</option>


                  {selectedCountry.networks.map(
                    (
                      networkName,
                      index
                    ) => (

                      <option
                        key={
                          index
                        }
                        value={
                          networkName
                        }
                      >
                        {networkName}
                      </option>

                    )
                  )}

                </select>

              </div>

            )}


            {/* ===============================================
                WALLET NUMBER
            =============================================== */}

            {selectedCountry && (

              <div className="wallet-field">

                <label>{t("Wallet Number")}</label>


                <div className="wallet-number-input">

                  <span>
                    {selectedCountry.code}
                  </span>


                  <input
                    type="tel"
                    inputMode="numeric"
                    value={
                      number
                    }
                    onChange={
                      handleNumberChange
                    }
                    placeholder={t("Enter account number")}
                    autoComplete="tel"
                    disabled={
                      saving
                    }
                  />

                </div>

              </div>

            )}


            {/* ===============================================
                NUMBER ERROR
            =============================================== */}

            {numberError && (

              <div className="wallet-field-error">

                <span className="error-symbol">
                  !
                </span>

                <span>
                  {numberError}
                </span>

              </div>

            )}


            {/* ===============================================
                GENERAL ERROR
            =============================================== */}

            {error && (

              <div className="wallet-field-error">

                <span className="error-symbol">
                  !
                </span>

                <span>
                  {error}
                </span>

              </div>

            )}


            {/* ===============================================
                SECURITY NOTICE
            =============================================== */}

            <div className="wallet-modal-security">

              <span>
                🔒
              </span>

              <p>{t("Make sure the wallet number and network are correct before confirming.")}</p>

            </div>


            {/* ===============================================
                CONFIRM
            =============================================== */}

            <button
              type="button"
              className="wallet-confirm-button"
              onClick={
                handleSave
              }
              disabled={
                saving
              }
            >

              {saving
                ? "SAVING..."
                : "CONFIRM WALLET"
              }

            </button>


            {/* ===============================================
                CANCEL
            =============================================== */}

            <button
              type="button"
              className="wallet-cancel-button"
              onClick={
                closeModal
              }
              disabled={
                saving
              }
            >{t("Cancel")}</button>


          </div>

        </div>

      )}

    </div>

  );

}
